<div
    *ngIf="
        complementaryReportContent != 'null' &&
        complementaryReportContent != undefined &&
        complementaryReportContent != ''
    "
>
    <div
        [innerHtml]="complementaryReportContent | safeHtml"
        [style.--selected-background-color]="backgroundColor"
        [style.color]="textColor"
    ></div>
</div>
